import { Box, Flex } from '@chakra-ui/react';
import ForgotPasswordForm from 'components/ForgotPassword/ForgotPasswordForm';
import { ThemeContext } from 'contexts/themeContext';
import image from 'resources/shutterstock_691534279.jpg';
import { Link } from 'components/UI';
import LoggedInMessage from 'components/common/LoggedInMessage/LoggedInMessage';
import { PageTitle } from 'components/common/PageTitle';
import { useUser } from 'contexts';
import { base2ColourGradient } from 'constants/theme';

const ForgotPassword = () => {
  const [user] = useUser();

  const renderContent = user ? (
    <LoggedInMessage />
  ) : (
    <>
      <Box mb={4}>
        <ForgotPasswordForm url={`${window.location.host}/recoverpassword`} />
      </Box>
      <Link to="/">Back to login</Link>
    </>
  );

  return (
    <ThemeContext.Consumer>
      {() => (
        <Box
          sx={{
            bgColor: 'white',
            bgImage: `url(${image})`,
            w: 'full',
            bgSize: '2000px 1000px',
          }}
          data-testid="forgot-password-page"
        >
          <Flex
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              w: 'full',
              bg: base2ColourGradient,
              height: '100vh',
            }}
          >
            <Box
              sx={{
                textAlign: 'center',
                bgColor: 'white',
                py: 8,
                px: 6,
                borderRadius: 6,
              }}
            >
              <PageTitle>Forgot Password</PageTitle>
              {renderContent}
            </Box>
          </Flex>
        </Box>
      )}
    </ThemeContext.Consumer>
  );
};

export default ForgotPassword;
